import React from "react";
import { H1 } from "../Headers";
import styled from "styled-components";
import IntegrationListWithData from "../integrations/IntegrationListWithData";
import { connect } from "react-redux";
import { IApplicationState } from "../../store";
import { selectCompany } from "../../store/context/selectors";
import ICompany from "../../models/ICompany";
import ScrollToTopOnMount from "../ScrollToTopOnMount";

const Container = styled.div`
  margin: 3em;
`;

export interface IManageIntegrationsProps {
  company?: ICompany;
}

const ManageIntegrations = (props: IManageIntegrationsProps) => {
  const { company } = props;
  return (
    <Container>
      <ScrollToTopOnMount />
      <H1>Manage Integrations</H1>
      {company && <IntegrationListWithData company={company} />}
    </Container>
  );
};

export default connect((state: IApplicationState) => {
  return {
    company: selectCompany(state),
  };
})(ManageIntegrations);
